// extracted by mini-css-extract-plugin
export default {"container":"Information_container__wNIiY","top":"Information_top__6T4O2","content":"Information_content__3iJB8"};